(() => {
  const registry = window.E11FriendsCarousels || new WeakSet();
  window.E11FriendsCarousels = registry;

  function init(root) {
    root.querySelectorAll('[data-e11-friends]').forEach((carousel) => {
      if (registry.has(carousel)) return;
      registry.add(carousel);

      const slides = [...carousel.querySelectorAll('[data-e11-slide]')];
      const dots = [...carousel.querySelectorAll('[data-e11-friends-dot]')];
      const previous = carousel.querySelector('[data-e11-friends-prev]');
      const next = carousel.querySelector('[data-e11-friends-next]');
      const status = carousel.querySelector('[data-e11-friends-status]');
      const names = ['Family', 'ELE', 'RIVER', 'WING', 'SCOUT'];
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      let index = 0;
      let timer;
      let pointerStart = null;

      function show(target, announce = true) {
        index = (target + slides.length) % slides.length;
        slides.forEach((slide, slideIndex) => {
          const active = slideIndex === index;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', String(!active));
        });
        dots.forEach((dot, dotIndex) => {
          const active = dotIndex === index;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-selected', String(active));
          dot.tabIndex = active ? 0 : -1;
        });
        if (announce && status) status.textContent = `${names[index]}, slide ${index + 1} of ${slides.length}`;
      }

      function stop() {
        if (timer) window.clearInterval(timer);
        timer = undefined;
      }

      function start() {
        stop();
        if (carousel.dataset.autoplay !== 'true' || reduceMotion) return;
        const interval = Number(carousel.dataset.interval) || 8000;
        timer = window.setInterval(() => show(index + 1, false), interval);
      }

      previous?.addEventListener('click', () => { show(index - 1); start(); });
      next?.addEventListener('click', () => { show(index + 1); start(); });
      dots.forEach((dot, dotIndex) => dot.addEventListener('click', () => { show(dotIndex); start(); }));

      carousel.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft') { event.preventDefault(); show(index - 1); }
        if (event.key === 'ArrowRight') { event.preventDefault(); show(index + 1); }
      });
      carousel.addEventListener('mouseenter', stop);
      carousel.addEventListener('mouseleave', start);
      carousel.addEventListener('focusin', stop);
      carousel.addEventListener('focusout', start);
      carousel.addEventListener('pointerdown', (event) => { pointerStart = event.clientX; });
      carousel.addEventListener('pointerup', (event) => {
        if (pointerStart === null) return;
        const distance = event.clientX - pointerStart;
        pointerStart = null;
        if (Math.abs(distance) < 48) return;
        show(distance > 0 ? index - 1 : index + 1);
        start();
      });

      show(0, false);
      start();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
